<template>
    <div>
        <vs-popup
      class="holamundo"
      title="Ürün Sil"
      :active.sync="deletePopupActive"
      v-esc="escape"
    >
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Kategoriyi Silmek İstediğinize Eminmisiniz ?</p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button
          type="gradient"
          color="primary"
          @click="
            deletePopupActive = false;
            deletedId = null;
          "
          >Vazgeç</vs-button
        >
        <vs-button
          type="gradient"
          color="danger"
          icon-pack="feather"
          icon="icon-trash"
          @click="deleteCategory(deletedId)"
        >
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
    <vs-button @click="openAddModal" color="primary" type="filled" style="margin-top: 20px;">Yeni Kategori Ekle</vs-button>
      <vs-table search :data="userWantCategories">
        <template slot="header">
          <h3>
            Kullanıcı İstek Kategorileri
          </h3>
        </template>
        <template slot="thead">
          <vs-th sort-key="name">
            Kategori Adı
          </vs-th>
          <vs-th>
            İşlemler
          </vs-th>
        </template>
  
        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name">
              {{data[indextr].name}}
            </vs-td>
            <vs-td>
                <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="
                  editCategory(tr)
                "
              />              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="
                  deletedId = tr.id;
                  deletePopupActive = true;
                "
              />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
  
      
  
      <!-- Add/Edit Modal -->
      <vs-popup class="holamundo" title="Kategori Ekle/Düzenle" :active.sync="popupActive" @close="closePopup">
        <div class="con-form">
          <vs-input v-model="currentCategory.name" label="Kategori Adı" class="mt-5 w-full" />
          <v-select id="role" name="Rol" v-validate="'required'" v-model="currentCategory.validRoles"
              label="name" placeholder="Rol Seçimi.." :options="roles" class="mt-4" :clearable="true"
              multiple></v-select>
          <vs-button @click="saveCategory" color="primary" type="filled" style="margin-top: 20px;">Kaydet</vs-button>
        </div>
      </vs-popup>
    </div>
  </template>
  
  <script>
  import { getAllUserWantCategories, addUserWantCategory, updateUserWantCategory, deleteUserWantCategory } from "@/api/UserWantCategory";
  import { getRoleList } from "@/api/Role.js";
  export default {
    data() {
      return {
      roles: [],
      userWantCategories: [],
      popupActive: false,
      deletedId: null,
      deletePopupActive: false,
      currentCategory: {
        id: null,
        name: '',
        validRoles: []
      },
      
    }
    },
    created: async function () {
      await this.loadCategories();
      await this.loadRoles();
    },
    mounted: async function () {
      await this.loadRoles();
    },
    methods: {
      async loadRoles() {
        try {
         console.log(this.roles);
          
        const response = await getRoleList();
        this.roles = response.data;
        console.log(this.roles);
        
      } catch (error) {
        this.$vs.notify({
            color: "danger",
            title: "Hata!",
            text: "Roller yüklenirken bir hata oluştu!"
          });
        }
      },
      async loadCategories() {
        try {
          const response = await getAllUserWantCategories();
          this.userWantCategories = response.data;
        } catch (error) {
          this.$vs.notify({
            color: "danger",
            title: "Hata!",
            text: "Kategoriler yüklenirken bir hata oluştu!"
          });
        }
      },
      openAddModal() {
        this.currentCategory = { id: null, name: '', validRoles: [] };
        this.popupActive = true;
      },
      editCategory(category) {
        this.currentCategory = { 
          ...category, 
          validRoles: category.validRoles 
            ? this.roles.filter(role => category.validRoles.includes(role.name))
            : []
        };
        this.popupActive = true;
      },
      async saveCategory() {
        const categoryData = {
          ...this.currentCategory,
          validRoles: this.currentCategory.validRoles.map(role => role.name)
        };
        try {
          if (this.currentCategory.id) {
            await updateUserWantCategory(categoryData);
          } else {
            await addUserWantCategory(categoryData);
          }
          await this.loadCategories();
          this.popupActive = false;
          this.$vs.notify({
            color: "success",
            title: "Başarılı!",
            text: "Kategori başarıyla kaydedildi!"
          });
        } catch (error) {
          this.$vs.notify({
            color: "danger",
            title: "Hata!",
            text: "Kategori kaydedilirken bir hata oluştu!"
          });
        }
      },
      async deleteCategory(id) {
        try {
          await deleteUserWantCategory(id);
          await this.loadCategories();
          this.deletePopupActive = false;
          this.$vs.notify({
            color: "success",
            title: "Başarılı!",
            text: "Kategori başarıyla silindi!"
          });
        } catch (error) {
          this.$vs.notify({
            color: "danger",
            title: "Hata!",
            text: "Kategori silinirken bir hata oluştu!"
          });
        }
      }
    }
  }
  </script>